export type UpsFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type UpsFilterGroup = {
  id: string;
  label: string;
  options: UpsFilterOption[];
};

export const upsFilterGroups: UpsFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'santak', label: 'Santak', keywords: ['santak'] },
      { value: 'cyber-power', label: 'Cyber Power', keywords: ['cyber power', 'cyberpower'] },
      { value: 'hikvision', label: 'Hikvision', keywords: ['hikvision'] },
    ],
  },
];
